import React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import { IJadwaOrder } from '../../../../types/jadwa';
import { getJadwaAmountBreakdowns } from './helpers';
import { formatSar } from '../derayah/format';

interface JadwaOrderProps {
  order: IJadwaOrder;
}

function AmountRow({ label, value, strong }: { label: string; value: string | null; strong?: boolean }) {
  return (
    <>
      <Divider variant="inset" />
      <Grid item container>
        <Grid item xs={6}>
          <Typography variant="subtitle1">{label}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body2" sx={strong ? { fontWeight: 700 } : undefined}>
            {value ?? '—'}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}

export function JadwaOrder({ order }: JadwaOrderProps) {
  const { client, satellite } = getJadwaAmountBreakdowns(order);
  const hasAmounts = order.netAmount != null;

  return (
    <Grid item container flexDirection="column" component={Paper} sx={{ p: '24px', mt: 0 }} spacing={2}>
      <Typography variant="h6">Order</Typography>
      <Divider variant="inset" />
      <Grid item container>
        <Grid item xs={6}>
          <Typography variant="subtitle1">Step</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body2">{order.step}</Typography>
        </Grid>
      </Grid>
      <Divider variant="inset" />
      <Grid item container>
        <Grid item xs={6}>
          <Typography variant="subtitle1">Fund Order Id</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body2">{order.fundOrderId}</Typography>
        </Grid>
      </Grid>
      <Divider variant="inset" />
      <Grid item container>
        <Grid item xs={6}>
          <Typography variant="subtitle1">Side</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body2">{order.side}</Typography>
        </Grid>
      </Grid>
      <Divider variant="inset" />
      <Grid item container>
        <Grid item xs={6}>
          <Typography variant="subtitle1">Error</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body2">{order.error}</Typography>
        </Grid>
      </Grid>
      {/* What ops invests — the wire's FX spread and transfer fee already taken off (saved by madkhol-jadwa). */}
      {hasAmounts && (
        <>
          <AmountRow label="Transfer Channel" value={order.transferChannel ?? '—'} />
          <AmountRow label="Client Gross" value={formatSar(client.gross)} />
          <AmountRow label="Client FX Deduction" value={formatSar(client.fx)} />
          <AmountRow label="Client Transfer Fee" value={formatSar(client.fee)} />
          <AmountRow label="Client Net (invest)" value={formatSar(client.net)} strong />
          <AmountRow label="Satellite Gross" value={formatSar(satellite.gross)} />
          <AmountRow label="Satellite FX Deduction" value={formatSar(satellite.fx)} />
          <AmountRow label="Satellite Transfer Fee" value={formatSar(satellite.fee)} />
          <AmountRow label="Satellite Net (invest)" value={formatSar(satellite.net)} strong />
          <AmountRow label="Total to Invest" value={formatSar(client.net + satellite.net)} strong />
        </>
      )}
    </Grid>
  );
}
